import { ThunkApiType } from 'types/storeTypes';
import authFetch, { checkForUnauthorizedResponse } from '../../utils/axios';

import { MemberThunkProps } from 'types/Members';
import { createUrlFromBlob } from 'utils/download';

export const getMemberDetailsThunk = async (
	props: MemberThunkProps & {
		callback: () => void;
	},
	thunkAPI: ThunkApiType,
) => {
	let getMemberDetailsURL = `/member/portalMemberDetail`;

	const { dateOfService, subscriptionUuid } = props;

	if (subscriptionUuid && dateOfService !== '') {
		getMemberDetailsURL =
			getMemberDetailsURL +
			`?subscriptionUuid=${subscriptionUuid}&dateOfService=${dateOfService}`;

		try {
			const response = await authFetch.get(getMemberDetailsURL);
			props.callback();
			return { ...response.data, subscriptionUuid };
		} catch (error: ThunkApiType) {
			return checkForUnauthorizedResponse(error, thunkAPI);
		}
	}
};

export const downloadMemberBenefitsThunk = async (
	{
		subscriptionUuid,
		dateOfService,
		fileName,
		print,
	}: {
		subscriptionUuid: string;
		dateOfService: string;
		fileName: string;
		print: boolean;
	},
	thunkAPI: ThunkApiType,
) => {
	const url = `/members/subscriptions/${subscriptionUuid}/providerBenefits/download`;
	try {
		const response = await authFetch.post(
			url,
			{ dateOfService },
			{
				responseType: 'blob',
			},
		);

		return {
			documentUrl: createUrlFromBlob(response.data, print),
			print,
			fileName,
		};
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
